import React from 'react'
import AppWrapper from '../../layout/AppWrapper'
import '../../../assets/css/profileStyles.css'
import bg_logo from '../../../assets/images/auth_page_background.png'
import { useDispatch, useSelector } from 'react-redux'
import { notap_user_roles } from '../../../constants/english'
import GeneralWrapper from '../../layout/GeneralWrapper'
import ChangePasswordModal from './ChangePasswordModal'
import { showChangePasswordFormFunc } from '../../../config/redux/slice/appSlice'

export default function UserProfile() {
  const dispatch = useDispatch()
  const {
        token,
        userData,
        email
    } = useSelector((state) => state.authData)

    const {
        userManagement: {  showChangePasswordForm }
    } = useSelector((state) => state.app)

  return (
    <GeneralWrapper pageTitle={'Profile'}>
    <div className="content p-0">
      {showChangePasswordForm && <ChangePasswordModal/>}
<div className="card card-default card-profile">

  <div className="card-header-bg" style={{
    background:`linear-gradient(270deg, rgba(0, 0, 0,0.5), rgba(27, 59, 74,0.5)), url(${bg_logo})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
    }}>
    
  </div>

  <div className="card-body card-profile-body">

    <div className="profile-avata">
      <div className='avatar-name rounded-circle'>
        <span>O</span>
      </div>
      <span className="h5 d-block mt-3 mb-2">{userData?.fullname}</span>
      <span className="d-block">{email}</span>
    </div>

  </div>

</div>

<div className="row">
  {/* <div className="col-lg-6"> */}
    {/* <!-- Notification --> */}
    <div className="card card-default col-lg-6">
      <div className="card-header">
        <h2>Personal Information</h2>
      </div>

      <div className="card card-default">
        <div className="card-body px-2 px-md-6">
          <table className="table table-borderless table-thead-border table-striped">
            <thead>
            </thead>
            <tbody>
              {/* <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Issuer</td>
                <td className="py-2 px-2 text-right text-dark">{certificateObject?.CERTIFICATE_ISSUER}</td>
              </tr> */}
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">First Name</td>
                <td className="py-2 px-2 text-right text-dark">{userData?.firstname}</td>
              </tr>
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Last Name</td>
                <td className="py-2 px-2 text-right text-dark">{userData?.lastname}</td>
              </tr>
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Email</td>
                <td className="py-2 px-2 text-right text-dark">{email}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  {/* </div> */}
  {notap_user_roles.includes((userData?.user_role).toLowerCase()) == false &&
  <>
  {/* <div className="col-lg-6"> */}
    {/* <!-- Notification --> */}
    <div className="card card-default col-lg-6">
      <div className="card-header">
        <h2>{userData?.user_role == 'BANK_USER' ? 'Bank Information' : 'Contact Information'}</h2>
      </div>

      <div className="card card-default">
        <div className="card-body px-2 px-md-6">
          <table className="table table-borderless table-thead-border table-striped">
            <thead>
            </thead>
            <tbody>
              {/* <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Issuer</td>
                <td className="py-2 px-2 text-right text-dark">{certificateObject?.CERTIFICATE_ISSUER}</td>
              </tr> */}
              {userData?.user_role == 'BANK_USER' && 
              <> 
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Bank Name</td>
                <td className="py-2 px-2 text-right text-dark">{userData?.bank_name}</td>
              </tr>
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Position</td>
                <td className="py-2 px-2 text-right text-dark">{userData?.user_bank_role}</td>
              </tr>
              </>}
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Contact Email</td>
                <td className="py-2 px-2 text-right text-dark">{userData?.contact_email}</td>
              </tr>
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Phone Number</td>
                <td className="py-2 px-2 text-right text-dark">{userData?.phone_number}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  {/* </div> */}</>
  }

  <div className="card card-default col-lg-6">
      <div className="card-header">
        <h2>Settings</h2>
      </div>

      <div className="card card-default">
        <div className="card-body px-2 px-md-6">
          <table className="table table-borderless table-thead-border table-striped">
            <thead>
            </thead>
            <tbody>
              <tr>
                <td className="py-2 px-2 text-dark font-weight-bold">Password</td>
                <td className="py-2 px-2 text-right text-dark">
                  <button className='btn btn-sm btn-primary' onClick={()=>{dispatch(showChangePasswordFormFunc({ modal: true }));}}>Change Password </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>

</div>
</GeneralWrapper>
  )
}
